import CopyIcon from '@elementor/icons/CopyIcon';
import IconButton from '@elementor/ui/IconButton';
import Tooltip from '@elementor/ui/Tooltip';
import PropTypes from 'prop-types';
import { useCopyToClipboard } from '@hooks/use-copy-to-clipboard';
import { __ } from '@utils/i18n';

const IssueElementSnippetCopyButton = ({ snippet }) => {
	const { copied, copyToClipboard } = useCopyToClipboard();

	return (
		<Tooltip
			arrow
			placement="top"
			title={copied ? __('Copied!') : __('Copy')}
			PopperProps={{
				disablePortal: true,
			}}
		>
			<IconButton
				size="tiny"
				onClick={copyToClipboard(snippet, 'error_snippet', 'assistant')}
			>
				<CopyIcon fontSize="tiny" />
			</IconButton>
		</Tooltip>
	);
};

IssueElementSnippetCopyButton.propTypes = {
	snippet: PropTypes.string.isRequired,
};

export default IssueElementSnippetCopyButton;
